import instrumentationMixin from '@/mixins/Analytics';
import { getCurrentInstance } from 'vue';
import { telemetryUserAttributes } from '@/utilities/analytics';

const useAnalyticsMixin = () => {
  const instance = getCurrentInstance();
  const { proxy } = instance ?? {};

  // Bind methods and computed states to the mixin methods `this` context
  const boundMethods = {};

  Object.keys(instrumentationMixin.methods).forEach((method) => {
    boundMethods[method] = instrumentationMixin.methods[method].bind({
      ...proxy,
      ...instrumentationMixin.methods,
      devTools: proxy?.$store?.state?.devTools,
      telemetryUserAttributes: telemetryUserAttributes(proxy?.$store?.getters?.currentUser),
    });
  });

  // provide to consumers the mixin with overridden methods and the data eventNames
  return {
    ...instrumentationMixin,
    methods: boundMethods,
    ...boundMethods,
    eventNames: instrumentationMixin.data().eventNames,
  };
};

export default useAnalyticsMixin;
